// Sentry init MUST be the first import
import { initSentry } from './lib/sentry-config'
initSentry()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App'
import { AppErrorBoundary } from './components/ErrorBoundary'
import { detectAndCleanIncompatibleCaches } from '@/lib/pwa-cleanup'

// Clean incompatible caches on version change
const cacheVersion = import.meta.env.VITE_CACHE_VERSION || '1.0.0'
void detectAndCleanIncompatibleCaches(cacheVersion).then((result) => {
  if (result.detected && result.cleaned) {
    console.log(
      `[PWA] Cleaned ${result.cachesCleared.length} caches`,
      result.cachesCleared
    )
  }
})

const root = createRoot(document.getElementById('root')!, {
  // React 19 error handlers - route errors to Sentry
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack)
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
})

root.render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>,
)
